export default function TabButton({ active, onClick, icon: Icon, label }) {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col items-center justify-center gap-1 py-2 px-1 rounded-lg transition-colors ${
        active
          ? "text-[#10B981] glow-mint"
          : "text-zinc-500 hover:text-zinc-400"
      }`}
    >
      <Icon size={24} />
      <span className="text-[10px] font-semibold">{label}</span>
    </button>
  );
}
